import { API_URL } from '../../config/constants';
import { toast } from 'react-toastify';

export const getPeopleByComunity = async (userName, passwd, filter) => {
    try {
        const request = new Request(API_URL + "/v2/getPeopleByComunity", {
            method: 'POST',
            body: JSON.stringify({
                username: userName,
                password: passwd,
                filter: filter
            }),
            headers: new Headers({
                'Content-Type': 'application/json'
            })
        });
        const response = await fetch(request);
        if (response.status !== 200 && response.code !== 200) throw response;
        const json = await response.json();
        return json;
    } catch (err) {
        if (!err.code && !err.status) err.status = 500;
        throw err;
    }
}


export const uploadExcellDataSet = data => {
    let stateData = [];
    let total = 0;
    for (let i = 0; i < data.length; i++) {
        total += parseInt(data[i].personas, 10);
    }
    stateData = [...data];
    stateData.push({ state_name: "Total", personas: total });
    let excellData = {
        columns: [{
            label: "Comunidade",
            value: "state_name"
        }, {
            label: "Visitantes",
            value: "personas"
        }],
        data: stateData ? stateData : [],
        key: "state_data"
    };
    return excellData;
}


export const loadData = async (sessionData, filter) => {
    try {
        let responseComunity = await getPeopleByComunity(sessionData.userName, sessionData.passwd, filter);
        let excellData = uploadExcellDataSet(responseComunity.result.data);
        return { data: responseComunity.result.data, excellData: excellData, total: responseComunity.result.total };
    } catch (err) {
        console.error(err);
        toast("Produciuse un erro ao obter os datos. Intenteo de novo máis tarde", { className: "toast-error", autoClose: 3500 });
    }
}



// WEBPACK FOOTER //
// ./src/controllers/results/peopleByComunity.js